import { render, staticRenderFns } from "./WriteoffSummaryTable.vue?vue&type=template&id=012a4b17&scoped=true&"
import script from "./WriteoffSummaryTable.vue?vue&type=script&lang=js&"
export * from "./WriteoffSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./WriteoffSummaryTable.vue?vue&type=style&index=0&id=012a4b17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012a4b17",
  null
  
)

export default component.exports